<div class="bg-section"></div>
<img
  src="/assets/img/bg-photo.jpg"
  alt="placeholder photo"
  class="img-sticky d-block d-md-none"
/>
<div class="content-box fh">
  <div class="row">
    <div class="col-sm-12 col-lg-6 offset-lg-3">
      <h1 class="d-flex align-items-center">
        <span class="icon-wrap text-secondary-accent me-2">
          <fa-icon [icon]="['fas', 'praying-hands']"></fa-icon>
        </span>
        <span class="ms-2">{{ "THANK YOU" | translate }}</span>
      </h1>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col-lg-6 offset-lg-3 mb-4">
      <div class="card bg-light relative">
        <div class="card-body">
          <p>
            <strong
              >Your 8 week access to the RECHARGE programme has now
              concluded.</strong
            >
          </p>
          <p>
            Thank you for using this resource and we hope you continue to use
            the techniques you have learnt in your daily life.
          </p>
        </div>
        <div class="card-footer bg-secondary">
          <a (click)="onLogout()" class="card-link stretched-link">
            {{ "LOGOUT" | translate }}</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
